import {ChangeDetectorRef, Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material';
import {MenuCategoryModel} from '../../../models/menu-category.model';
import {AWSService} from '../../../../provider/aws.service';
import {UserService} from '../../../../provider/user.service';

@Component({
  selector: 'kt-change-image',
  templateUrl: './change-image.popup.html',
  styleUrls: ['./change-image.popup.scss']
})
export class ChangeImagePopup implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: MenuCategoryModel,
              public awsService: AWSService,
              private userService: UserService,
              private readonly changeDetectorRef: ChangeDetectorRef) {
  }

  ngOnInit() {
    this.awsService.getImages(this.userService.record_change$.getValue().app_hotel_id, 'Categories', this.data.id);
  }

  imgUploadClick() {
    document.getElementById('file1').click();
  }

  imgUpload2Click() {
    document.getElementById('file2').click();
  }

  uploadFile(event: any) {
    let imageName = '';

    if (event.target.files && event.target.files.length > 0) {
      for (const file of event.target.files) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          const format = file.type.split('/')[1];
          imageName = this.data.id.toString() + '.' + format;
          this.awsService.uploadImage(file, this.userService.record_change$.getValue().app_hotel_id, 'Categories', imageName).subscribe(
            () => {
              this.awsService.getImages(this.userService.record_change$.getValue().app_hotel_id, 'Categories', this.data.id);
              this.changeDetectorRef.markForCheck();
            }, (err) => {
              console.log(err);
            }
          );
        };
      }
    }
  }

  deleteImage() {
    const images = this.awsService.categoryImage_change$.getValue();
    console.log('Burdayım');
    this.awsService.deleteImage(this.userService.record_change$.getValue().app_hotel_id, 'Categories', images.file_name).subscribe(
      () => this.awsService.categoryImage_change$.next(undefined)
    );
  }
}
